<template>
  <FeedbackStep :title="title" :number="number">
    <template v-slot:content>
      <div class="feedback-form">
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q7AnswerYes"
            type="radio"
            name="q7Answer"
            value="tak"
            v-model.trim="form.answer_q7"
            @input="delayTouch($v.form.answer_q7)"
            @click="hasDescription = false"
          />
          <label for="q7AnswerYes" class="form__label">tak</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q7AnswerNo"
            type="radio"
            name="q7Answer"
            value="nie"
            v-model.trim="form.answer_q7"
            @input="delayTouch($v.form.answer_q7)"
            @click="hasDescription = false"
          />
          <label for="q7AnswerNo" class="form__label">nie</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q7AnswerSometimes"
            type="radio"
            name="q7Answer"
            value="czasami"
            v-model.trim="form.answer_q7"
            @input="delayTouch($v.form.answer_q7)"
            @click="hasDescription = false"
          />
          <label for="q7AnswerSometimes" class="form__label">czasami</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q7AnswerOnly"
            type="radio"
            name="q7Answer"
            value="tylko zanim pewne rzeczy zostały wyjaśnione"
            v-model.trim="form.answer_q7"
            @input="delayTouch($v.form.answer_q7)"
            @click="hasDescription = false"
          />
          <label
            for="q7AnswerOnly"
            class="form__label"
          >tylko zanim pewne rzeczy zostały wyjaśnione</label>
        </div>
        <div class="form__input-wrapper form__input-wrapper--check">
          <input
            id="q7AnswerOther"
            type="radio"
            name="q7Answer"
            value="inna odpowiedź"
            v-model.trim="form.answer_q7"
            @input="delayTouch($v.form.answer_q7)"
            @change="otherHandler"
          />
          <label for="q7AnswerOther" class="form__label">inna odpowiedź</label>
        </div>
        <transition name="fade-input">
          <div
            v-if="hasDescription"
            class="form__input-wrapper"
            :class="{ error: $v.form.answer_q7_content.$anyError }"
          >
            <label for="answer_q7_content" class="form__label uk-hidden"
              >Podaj inne</label
            >
            <input
              class="form-input uk-width-1-1"
              id="answer_q7_content"
              type="text"
              name="answer_q7_content"
              ref="otherInput"
              @input="event => delayTouchCounterComposition(
                $v.form,
                'answer_q7_content',
                event.target.value
              )"
            />
            <span class="form__error-message form__error-message--no-label">
              <template v-if="!$v.form.answer_q7_content.minLength">
                {{ validationMessage.minLength }}</template
              >
              <template v-if="!$v.form.answer_q7_content.required">
                {{ validationMessage.required }}</template
              >
            </span>
          </div>
        </transition>
      </div>
    </template>
  </FeedbackStep>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators';
import stepValidation from '../../mixins/stepValidation';
import FeedbackStep from '../global/FeedbackStep.vue';

export default {
  name: 'Question7',
  components: { FeedbackStep },
  mixins: [stepValidation],
  data: () => ({
    title: 'Czy w czasie realizowania usługi odczuwał(a) Pan/Pani takie emocje jak: frustracja, niepokój, irytacja, zdenerwowanie wywołane działaniami lub komunikacją z Solveit?',
    number: 7,
    form: {
      answer_q7: null,
      answer_q7_content: '',
    },
    hasDescription: false,
  }),
  validations() {
    if (!this.hasDescription) {
      return {
        form: {
          answer_q7: {
            required,
          },
        },
      };
    }
    return {
      form: {
        answer_q7: {
          required,
        },
        answer_q7_content: {
          required,
          minLength: minLength(3),
        },
      },
    };
  },
  methods: {
    otherHandler() {
      this.hasDescription = true;

      if (!this.hasDescription) {
        this.form.answer_q7_content = '';
      } else {
        setTimeout(() => {
          this.form.answer_q7_content = '';
          this.$refs.otherInput.focus();
        }, 100);
      }
    },
  },
};
</script>
